import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import PageHeader from "../../components/shared/PageHeader";
import Loading from "../../components/shared/Loading";
import apiClient from "../../components/utils/apiClient";
import useUser from "../../components/helpers/useUser";
import { PACKAGE_BACKGROUND } from "../../components/styles/media";
import moment from "moment";
import { UserContext } from "../../App";
import { VENDOR_GOLDIE_TYPES } from "../../components/utils/constants";

const SettingsHomePage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle(t('settings.pageTitle'));
    const navigate = useNavigate();
    const [user,setUser] = useUser();
    const [vendor,setVendor] = useState(null);
    const pageTitle = {title: t('settings.pageTitle')};
    const {fields, confguration} = useContext(UserContext);

    const [showFields, setShowFields] = useState(false);
    const [showCities, setShowCities] = useState(false);

    const [cities, setCities] = useState(null);


    const getUserData = async () => {
      try {
        const response = await apiClient.get(`vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }
    

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
        }
    },[user])

    useEffect(()=>{
      if(moment) {
        moment?.locale('en-US');
      }
    },[])

    const getExtraTchCount = () => {
      let count;
      if(vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 && vendor?.workersCount > vendor?.activeSubscription?.plan?.features?.TechniciansCount) {
        count = vendor?.workersCount - vendor?.activeSubscription?.plan?.features?.TechniciansCount;
      } else {
        count = 0;
      }
      return count;
    }

    const getOriginalGoldie = () => {
      return vendor?.activeSubscription?.plan?.goldStarFees?.[vendor?.currentGoldenStarSubscriptionType];
    }

    const getExtraGoldie = () => {
      return getExtraTchCount() * vendor?.activeSubscription?.plan?.extraGoldStarFees?.[vendor?.currentGoldenStarSubscriptionType];
    }

    const getTotalGoldie = () => {
      return getOriginalGoldie() + getExtraGoldie();
    }

    const handleClickShowFields = () => {
      setShowFields(!showFields);
    }

    const handleClickShowCities = () => {
      setShowCities(!showCities);
    }

    useEffect(()=>{
      if(confguration?.enums?.districts) {
        setCities(confguration?.enums?.districts?.map(d=>({value:d?.id,label:d?.[i18n.language === 'ar' ? 'ar' : 'en'] || d?.ar})));
      }
    },[confguration, i18n.language])


  return (
    <div>
      <PageHeader pageTitle={pageTitle} />
      <PageMain>
        <MainContent>
          { vendor && <>
          {vendor?.activeSubscription?.isTrial ?
            <div className="w-full p-[24px] border-[1px] border-grey-300 rounded-[24px] bg-white mx-auto mt-[32px] mb-[16px] text-center">
              <img src="/assets/images/logo-b.svg" alt="" className="block mx-auto mb-[24px]" />
              <h2 className="text-[#F48B19] text-[24px] font-[700] leading-[36px] mb-[24px]">{t('settings.trialPeriod')}</h2>
              <h3 className="text-[#212E35] font-[700] text-[24px] text-center">{t('settings.trialDescription')}</h3>
            </div> : ''
          }
          <div className="border-[1px] border-grey-200 rounded-[16px] p-[20px] my-[25px] bg-white">
            <div className="flex flex-wrap lg:flex-nowrap lg:h-[146px]">
              <div className="w-full lg:w-[calc(100%-341px)]">
                {vendor?.activeSubscription
                ? <>
                <div className="text-darkBlue text-[24px] font-[600] leading-[36px] flex flex-wrap lg:flex-nowrap justify-between">
                  <div className="w-full lg:w-[50%]">
                    {t('settings.currentPackage')} {vendor?.activeSubscription?.plan?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || vendor?.activeSubscription?.plan?.name?.ar} {vendor?.activeSubscription?.isTrial ? t('settings.trialFree') : ''}
                  </div>
                  <div className="w-full lg:w-[50%] text-end pe-[20px] mt-[15px] lg:mt-0">
                    {moment(vendor?.activeSubscription?.endDate).diff(moment(), 'days')} {t('settings.remainingDays')}
                  </div>
                </div>
                <div className="flex flex-wrap lg:flex-nowrap mt-[25px] pt-[20px] border-t-[1px] border-grey-200">
                  <div className="w-[50%] lg:w-[200px] h-[60px] relative">
                    <strong className="text-[24px] text-darkBlue font-[600] leading-[36px]">{moment(vendor?.activeSubscription?.startDate).format('DD/MM/YYYY')}</strong>
                    <p className="text-[14px] text-grey-600 font-[500]">
                      <img src="/assets/images/settings-cal.svg" alt="" className="inline-block align-sub me-[3px]" />
                      {t('settings.subscriptionDate')}
                    </p>
                    <span className="absolute block w-[1px] h-[40px] bg-grey-300 end-0 top-[10px]"></span>
                  </div>
                  <div className="w-[50%] lg:w-[260px] h-[60px] ps-[60px] relative">
                    <strong className="text-[24px] text-darkBlue font-[600] leading-[36px]"><span className={`inline-block relative ${vendor?.activeSubscription?.isTrial ? 'opacity-50' : ''}`}>{vendor?.activeSubscription?.plan?.price} {vendor?.activeSubscription?.isTrial ? <span className={`w-full absolute top-[50%] end-0 border-t-[3px] border-darkblue`}></span> : ''}</span>{vendor?.activeSubscription?.isTrial ? ' 0' : ''} <img src="/assets/images/green-sar.svg" alt="" className="inline-block align-baseline me-[3px]" /></strong>
                    <p className="text-[14px] text-grey-600 font-[500]">
                      <img src="/assets/images/settings-price.svg" alt="" className="inline-block align-sub me-[3px]" />
                      {t('settings.subscriptionAmount')}
                    </p>
                    <span className="absolute w-[1px] h-[40px] bg-grey-300 end-0 top-[10px] hidden lg:block"></span>
                  </div>
                  <div className="w-[50%] lg:w-[200px] ltr:lg:w-[300px] lg:h-[60px] lg:ps-[60px] relative py-[15px] lg:py-0">
                    <strong className="text-[24px] text-darkBlue font-[600] leading-[36px]">{moment(vendor?.activeSubscription?.endDate).format('DD/MM/YYYY')}</strong>
                    <p className="text-[14px] text-grey-600 font-[500]">
                      <img src="/assets/images/settings-cal.svg" alt="" className="inline-block align-sub me-[3px]" />
                      {t('settings.subscriptionEndDate')}
                    </p>

                  </div>
                </div>
                </>
                : <div className="text-darkBlue text-[24px] font-[600] leading-[36px] pt-[50px]">{t('settings.noActivePackage')}</div> }
              </div>
              <div className="w-[341px] border-s-0 lg:border-s-[1px] border-grey-200 flex justify-end items-center">
                {vendor?.activeSubscription
                ? <Link to={`/${i18n?.language || 'ar'}/settings/packages`} className={`w-full lg:w-[324px] h-[48px] leading-[48px] bg-darkBlue text-white rounded-[8px] text-center font-[600] text-[18px] transition-transform hover:scale-105 ${vendor?.activeSubscription?.plan?.name?.en === 'growth' ? 'opacity-50 pointer-events-none' : ''}`}>{t('settings.upgradePackage')}</Link>
                : <Link to={`/${i18n?.language || 'ar'}/settings/packages`} className="w-full lg:w-[324px] h-[48px] leading-[48px] bg-darkBlue text-white rounded-[8px] text-center font-[600] text-[18px] transition-transform hover:scale-105">{t('settings.choosePackage')}</Link>}
              </div>
            </div>
            {vendor?.activeSubscription && <div className="pt-[25px] mt-[25px] border-t-[1px] border-grey-200">
              <div className="w-full flex flex-wrap lg:flex-nowrap">
                <div className="w-full lg:w-[50%]">

                  <div className="w-full bg-grey-200">

                    <div className="flex flex-nowrap px-[16px] h-[37px] leading-[37px]">

                      <div className="w-[50%] text-[14px] text-grey-600 font-[400]">{t('settings.techniciansCount')}</div>
                      <div className="w-[50%] text-end text-[14px] text-darkBlue font-[500]">
                        {vendor?.activeSubscription?.plan?.features?.TechniciansCount === 0 
                      ? <span>{vendor?.workersCount}/{t('settings.unlimited')}</span>
                      : <span>{vendor?.workersCount ? (vendor?.workersCount > vendor?.activeSubscription?.plan?.features?.TechniciansCount) ? vendor?.activeSubscription?.plan?.features?.TechniciansCount : vendor?.workersCount : 0}/<span dir="ltr">{vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 ? vendor?.activeSubscription?.plan?.features?.TechniciansCount : t('settings.unlimited')}</span> {(parseInt(vendor?.workersCount) - parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount)) > 0 ? <small className="inline-block align-top">{`(+${(parseInt(vendor?.workersCount) - parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount))} ${t('settings.outsidePackage')})`}</small> : '' }  </span>
                    }
                      </div>
                    
                    </div>

                  </div>

                  <div className="w-full bg-grey-50 px-[16px]">

                    <div className="flex flex-nowrap h-[37px] leading-[37px] cursor-pointer select-none" onClick={()=>handleClickShowCities()}>

                      <div className="w-[50%] text-[14px] text-grey-600 font-[400]">{t('settings.cities')}</div>
                      <div className="w-[50%] text-end text-[14px] text-darkBlue font-[500]">
                        
                        {Array.isArray(vendor?.city) ? vendor?.city?.length : 1}
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`inline-block ${showFields ? '' : 'rotate-180'}`}>
                          <path d="M16.2802 13.2599C16.2802 13.4499 16.2102 13.6399 16.0602 13.7899C15.7702 14.0799 15.2902 14.0799 15.0002 13.7899L12.0002 10.7899L9.00016 13.7899C8.71016 14.0799 8.23016 14.0799 7.94016 13.7899C7.65016 13.4999 7.65016 13.0199 7.94016 12.7299L11.4702 9.19995C11.7602 8.90995 12.2402 8.90995 12.5302 9.19995L16.0602 12.7299C16.2102 12.8799 16.2802 13.0699 16.2802 13.2599Z" fill="#475569"/>
                        </svg>

                      </div>

                    </div>

                    {showCities ? <div className="min-h-[37px] border-t-[1px] border-grey-300 pt-[6px] pb-[8px] text-[14px] text-grey-600 font-[400]">
                      {Array.isArray(vendor?.city) ?
                        vendor?.city?.map((city,index)=>{return (<div key={'city-'+city} className="inline-block">{index === 0 ? '' : '، '}{cities?.find(c=>c?.value === city)?.label}</div>)})
                        : cities?.find(c=>c?.value === vendor?.city)?.label}
                    </div> : ''}

                  </div>

                  <div className="w-full bg-grey-200">

                    <div className="flex flex-nowrap px-[16px] h-[37px] leading-[37px]">

                      <div className="w-[200px] lg:w-[50%] ltr:lg:w-[75%] text-[14px] text-grey-600 font-[400]">{t('settings.extraSpecializationFees')}</div>
                      <div className="w-[calc(100%-200px)] lg:w-[50%] ltr:lg:w-[25%] text-end text-[14px] text-darkBlue font-[500]">{vendor?.activeSubscription?.plan?.features?.FeesToSpecializations || 0} <img src="/assets/images/green-sar.svg" alt="" className="max-w-[11px] inline-block align-baseline" /></div>

                    </div>

                  </div>

                  <div className="w-full bg-grey-50">

                    <div className="flex flex-nowrap px-[16px] h-[37px] leading-[37px]">

                      <div className="w-[50%] text-[14px] text-grey-600 font-[400]">{t('settings.minRechargeAmount')}</div>
                      <div className="w-[50%] text-end text-[14px] text-darkBlue font-[500]">{vendor?.activeSubscription?.plan?.features?.MinRechargeAmount || 0} <img src="/assets/images/green-sar.svg" alt="" className="max-w-[11px] inline-block align-baseline" /></div>

                    </div>

                  </div>
                
                </div>
                <div className="w-full lg:w-[50%]">

                  <div className="w-full bg-grey-200 px-[16px]">

                    <div className="flex flex-nowrap h-[37px] leading-[37px] cursor-pointer select-none" onClick={()=>handleClickShowFields()}>

                      <div className="w-[50%] text-[14px] text-grey-600 font-[400]">{t('settings.specializations')}</div>
                      <div className="w-[50%] text-end text-[14px] text-darkBlue font-[500]">
                        
                        {vendor?.fields?.length || 0}
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`inline-block ${showFields ? '' : 'rotate-180'}`}>
                          <path d="M16.2802 13.2599C16.2802 13.4499 16.2102 13.6399 16.0602 13.7899C15.7702 14.0799 15.2902 14.0799 15.0002 13.7899L12.0002 10.7899L9.00016 13.7899C8.71016 14.0799 8.23016 14.0799 7.94016 13.7899C7.65016 13.4999 7.65016 13.0199 7.94016 12.7299L11.4702 9.19995C11.7602 8.90995 12.2402 8.90995 12.5302 9.19995L16.0602 12.7299C16.2102 12.8799 16.2802 13.0699 16.2802 13.2599Z" fill="#475569"/>
                        </svg>

                      </div>

                    </div>

                    {showFields ? <div className="min-h-[37px] border-t-[1px] border-grey-300 pt-[6px] pb-[8px] text-[14px] text-grey-600 font-[400]">
                      {vendor?.fields?.map((field,index)=>{return (<div key={'ff'+field} className="inline-block">{index === 0 ? '' : '، '}{fields?.find(f=>f?.field?.code === field)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === field)?.field?.name?.ar}</div>)})}
                    </div> : ''}

                  </div>

                  <div className="w-full bg-grey-50">

                    <div className="flex flex-nowrap px-[16px] h-[37px] leading-[37px]">

                      <div className="w-[200px] lg:w-[50%] ltr:lg:w-[75%] text-[14px] text-grey-600 font-[400]">{t('settings.extraTechFees')}</div>
                      <div className="w-[calc(100%-200px)] lg:w-[50%] ltr:lg:w-[25%] text-end text-[14px] text-darkBlue font-[500]">{vendor?.activeSubscription?.plan?.features?.ExtraTechsFees || 0} <img src="/assets/images/green-sar.svg" alt="" className="max-w-[11px] inline-block align-baseline" /></div>

                    </div>

                  </div>

                  <div className="w-full bg-grey-200">

                    <div className="flex flex-nowrap px-[16px] h-[37px] leading-[37px]">

                      <div className="w-[200px] lg:w-[50%] text-[14px] text-grey-600 font-[400]">{t('settings.minBalanceForRequests')}</div>
                      <div className="w-[calc(100%-200px)] lg:w-[50%] text-end text-[14px] text-darkBlue font-[500]">{vendor.activeSubscription?.plan?.features?.MinimumWalletBalance || 0} <img src="/assets/images/green-sar.svg" alt="" className="max-w-[11px] inline-block align-baseline" /></div>

                    </div>

                  </div>

                  <div className="w-full bg-grey-50">

                    <div className="flex flex-nowrap px-[16px]">

                    </div>

                  </div>

                </div>
              </div>
            </div>}
          </div>

          <div className="border-[1px] border-grey-200 rounded-[16px] p-[20px] my-[25px] bg-white">
            <div className="flex flex-nowrap">
              <div className="w-full">
                <div className="text-darkBlue text-[24px] font-[600] leading-[36px]">{t('settings.paidServicesAdded')}</div>

                <div className="mt-[20px] pt-[20px] border-t-[1px] border-grey-200">

                  <div className="w-full bg-grey-50 rounded-[12px] px-[16px] py-[8px]">
                    <div className="flex flex-wrap lg:flex-nowrap">

                      <div className="w-full lg:w-[50%] font-[600] text-[18px] text-grey-900 leading-[40px]">{t('settings.goldieSubscription')}</div>
                      <div className="w-full lg:w-[50%] text-end">
                        {vendor?.activeGoldenStarSubscriptions && Array.isArray(vendor?.activeGoldenStarSubscriptions) && vendor?.activeGoldenStarSubscriptions?.length > 0
                        ? <>
                            <div className="inline-block text-white font-[600] text-[18px] rounded-[8px] select-none px-[32px] py-[8px] bg-[#328E6E] w-full lg:w-auto text-center lg:text-start">  
                              {t('settings.subscribed')}
                            </div>
                            <Link to={`/${i18n?.language || 'ar'}/workers/goldie`} className="inline-block text-white font-[600] text-[18px] cursor-pointer rounded-[8px] select-none px-[32px] py-[8px] bg-darkBlue lg:ms-[15px] w-full lg:w-auto text-center lg:text-start mt-[15px] lg:mt-0">  
                              {t('settings.subscribeOtherSpecializations')}
                            </Link>
                          </>
                        : <Link to={`/${i18n?.language || 'ar'}/workers/goldie`} className="inline-block text-white font-[600] text-[18px] cursor-pointer rounded-[8px] select-none px-[32px] py-[8px] bg-darkBlue">  
                            {t('settings.subscribe')}
                          </Link>}
                      </div>

                    </div>

                    {vendor?.activeGoldenStarSubscriptions && Array.isArray(vendor?.activeGoldenStarSubscriptions) && vendor?.activeGoldenStarSubscriptions?.length > 0 ? 
                    vendor?.activeGoldenStarSubscriptions?.filter(s=>s?.status === 'active')?.map((subscription,index)=>{
                      return (<div key={'subscription-'+index} className="py-[8px] border-t-[1px] border-grey-200 flex flex-wrap lg:flex-nowrap mt-[8px] w-full">
                              <div className="w-[60%] lg:w-[25%] lg:max-w-[210px] relative text-start">
                                  <div className="inline-block text-start">
                                    <div className="leading-[36px] font-[600] text-[24px] text-darkBlue">
                                      {moment(subscription?.startDate).format('DD/MM/YYYY') || '-'}
                                    </div>
                                    <p className="text-[14px] text-grey-600 font-[500] mt-[4px]">
                                      <img src="/assets/images/settings-cal.svg" alt="" className="inline-block align-middle me-[4px]" />
                                      {t('settings.subscriptionDateLabel')}
                                    </p>
                                  </div>
                                  <span className="block absolute bg-grey-300 w-[1px] h-[40px] top-[10px] end-0"></span>
                                </div>
                                <div className="w-[40%] lg:w-[25%] lg:max-w-[210px] relative text-center">
                                  <div className="inline-block text-start">
                                    <div className="leading-[36px] font-[600] text-[24px] text-darkBlue">
                                      {fields?.find(f=>f?.field?.code === subscription?.goldenStarPlan?.field)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === subscription?.goldenStarPlan?.field)?.field?.name?.ar || '-'}
                                    </div>
                                    <p className="text-[14px] text-grey-600 font-[500] mt-[4px]">
                                      <img src="/assets/images/workers-fields-icon.svg" alt="" className="inline-block align-middle me-[4px]" />
                                      {t('settings.specializationLabel')}
                                    </p>
                                  </div>
                                  <span className="absolute bg-grey-300 w-[1px] h-[40px] top-[10px] end-0 hidden lg:block"></span>
                                </div>
                                <div className="full lg:w-[25%] lg:max-w-[210px] ltr:max-w-[350px] relative text-center mt-[15px] lg:mt-0">
                                  <div className="inline-block text-start">
                                    <div className="leading-[36px] font-[600] text-[24px] text-darkBlue">
                                      {subscription?.totalCost}
                                      <img src="/assets/images/green-sar.svg" alt="" className="inline-block align-baseline ms-[4px]" />
                                    </div>
                                    <p className="text-[14px] text-grey-600 font-[500] mt-[4px]">
                                      <img src="/assets/images/settings-price.svg" alt="" className="inline-block align-sub me-[3px]" />
                                      {t('settings.subscriptionAmountLabel')} {VENDOR_GOLDIE_TYPES[subscription?.goldenStarPlan?.subscriptionType]?.[i18n.language === 'ar' ? 'ar' : 'en'] || VENDOR_GOLDIE_TYPES[subscription?.goldenStarPlan?.subscriptionType]?.ar}
                                    </p>
                                  </div>
                                  <span className="absolute bg-grey-300 w-[1px] h-[40px] top-[10px] end-0 hidden lg:block"></span>
                                </div>
                                <div className="w-full lg:w-[25%] lg:max-w-[210px] relative lg:text-end mt-[15px] lg:mt-0">
                                  <div className="inline-block text-start">
                                    <div className="leading-[36px] font-[600] text-[24px] text-darkBlue">
                                      {moment(subscription?.endDate).format('DD/MM/YYYY') || '-'}
                                    </div>
                                    <p className="text-[14px] text-grey-600 font-[500] mt-[4px]">
                                      <img src="/assets/images/settings-cal.svg" alt="" className="inline-block align-middle me-[4px]" />
                                      {t('settings.subscriptionEndDateLabel')}
                                    </p>
                                  </div>
                                </div>
                              </div>)})
                     : ''}
                  </div>
                  
                </div>
              
              </div>
            </div>
            
          </div>
          </>}
          <br />
          <br />
        </MainContent>
      </PageMain>



      {!vendor && <Loading showLoading={true} />}
    </div>
  );
};

export default SettingsHomePage;
